import { gfmTable } from 'micromark-extension-gfm-table';
import { gfmStrikethrough } from 'micromark-extension-gfm-strikethrough';
import { gfmTaskListItem } from 'micromark-extension-gfm-task-list-item';
import { gfmTableFromMarkdown } from 'mdast-util-gfm-table';
import { gfmStrikethroughFromMarkdown } from 'mdast-util-gfm-strikethrough';
import { gfmTaskListItemFromMarkdown } from 'mdast-util-gfm-task-list-item';

/**
 * remark-gfm'in autolink-literal'sız sürümü.
 * Autolink eklentisi lookbehind regex kullanıyor; iOS 16.4 öncesi Safari bunu
 * ayrıştıramadığı için tüm JS paketi çöküyordu. Tablo, üstü çizili ve
 * yapılacak listesi desteği korunur.
 */
export default function remarkGfmSafe() {
  const data = this.data();
  const micromarkExtensions = data.micromarkExtensions || (data.micromarkExtensions = []);
  const fromMarkdownExtensions = data.fromMarkdownExtensions || (data.fromMarkdownExtensions = []);

  micromarkExtensions.push(gfmTable(), gfmStrikethrough(), gfmTaskListItem());
  fromMarkdownExtensions.push(
    gfmTableFromMarkdown(),
    gfmStrikethroughFromMarkdown(),
    gfmTaskListItemFromMarkdown(),
  );
}
